import { SortOrder } from '../../generated/graphql';
import { Ordering } from './types';


export const stableSort = <T>(array: T[], comparator: (a: T, b: T) => number) => {
    const stabilizedThis = array.map((el, index) => [el, index] as [T, number]);

    stabilizedThis.sort((a, b) => {
        const order = comparator(a[0], b[0]);
        if (order !== 0) return order;
        return a[1] - b[1];
    });

    return stabilizedThis.map(el => el[0]);
};

export const getComparator = <T>(order: Ordering, orderBy: keyof T) => {
    return order === 'desc'
        ? (a: T, b: T) => descendingComparator(a, b, orderBy)
        : (a: T, b: T) => -descendingComparator(a, b, orderBy);
};

const descendingComparator = <T> (a: T, b: T, orderBy: keyof T) => {
    if (b[orderBy] < a[orderBy]) {
        return -1;
    }
    if (b[orderBy] > a[orderBy]) {
        return 1;
    }
    return 0;
};

export const getNextOrdering = (prev: SortOrder | false) => {
    switch (prev) {
    case false:
        return SortOrder.Desc;
    case SortOrder.Desc:
        return SortOrder.Asc;
    default:
        return false;
    }
};
